import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function TermsAndConditions() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  }, []);

  return (
    <div style={{
      background: '#0a0a0a',
      minHeight: '100vh',
      color: '#ccc',
      fontFamily: "'DM Mono', monospace",
      padding: '40px 20px',
    }}>
      <style>{`
        ::-webkit-scrollbar { width: 24px; }
        ::-webkit-scrollbar-track { background: #1a1a1a; border-radius: 12px; }
        ::-webkit-scrollbar-thumb { background: #F0B800; border-radius: 12px; border: 3px solid #1a1a1a; }
        ::-webkit-scrollbar-thumb:hover { background: #FFE033; border: 2px solid #1a1a1a; }
        ::-webkit-scrollbar-thumb:active { background: #FFEF80; border: 2px solid #1a1a1a; }
        h2 { color: #F0B800; font-family: 'Bebas Neue', sans-serif; font-size: 28px; letter-spacing: 3px; margin-top: 40px; margin-bottom: 12px; border-bottom: 1px solid #222; padding-bottom: 8px; }
        h3 { color: #F0B800; font-size: 14px; letter-spacing: 2px; margin-top: 24px; margin-bottom: 8px; }
        p { line-height: 1.8; font-size: 13px; color: #aaa; margin-bottom: 12px; }
        ul { color: #aaa; font-size: 13px; line-height: 1.8; padding-left: 20px; margin-bottom: 12px; }
        .warning { background: rgba(240,184,0,0.08); border: 1px solid #F0B800; border-radius: 8px; padding: 16px 20px; margin: 20px 0; }
        .warning p { color: #F0B800; margin: 0; }
      `}</style>

      <div style={{ maxWidth: 860, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🐓</div>
          <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 42, color: '#F0B800', letterSpacing: 4 }}>
            CHICKEN DROP
          </div>
          <div style={{ fontSize: 13, color: '#888', letterSpacing: 2, marginTop: 4 }}>
            RULES · TERMS · CONDITIONS
          </div>
          <div style={{ fontSize: 11, color: '#555', marginTop: 8 }}>
            Last updated: January 2026
          </div>
        </div>

        <div className="warning">
          <p>⚠️ IMPORTANT: BY USING THIS PLATFORM YOU AGREE TO THESE TERMS IN FULL. IF YOU DO NOT AGREE, DO NOT USE THIS PLATFORM.</p>
        </div>

        {/* Age & Eligibility */}
        <h2>1. AGE & ELIGIBILITY</h2>
        <p>This platform is strictly intended for users aged 18 years or older. By accessing or using Chicken Drop you confirm that you are at least 18 years of age.</p>
        <p>Users in jurisdictions where games of chance, lottery-style games, or cryptocurrency-based gaming are prohibited or regulated are NOT permitted to participate. It is your sole responsibility to ensure that your use of this platform complies with all laws and regulations applicable in your jurisdiction.</p>
        <p>The following are expressly prohibited from using this platform:</p>
        <ul>
          <li>Any person under the age of 18</li>
          <li>Residents of jurisdictions where participation is unlawful</li>
          <li>Any person acting on behalf of a prohibited person</li>
        </ul>
        <div className="warning">
          <p>⚠️ IF YOU ARE UNDER 18 YEARS OF AGE, YOU MUST LEAVE THIS SITE IMMEDIATELY.</p>
        </div>

        {/* What is Chicken Droppings */}
        <h2>2. WHAT IS CHICKEN DROPPINGS?</h2>
        <p>Chicken Droppings is a pay-to-play arcade mini-game built into the Chicken Drop platform. Players control a rooster and must defend the coop by shooting poop projectiles at incoming weapons across 10 progressive rounds.</p>
        <p>Completing the Chicken Droppings game earns the player free squares in the Chicken Drop arena:</p>
        <ul>
          <li>Surviving any number of rounds (losing): 1 free square</li>
          <li>Completing all 10 rounds (winning): 1 free square</li>
        </ul>
        <p>Chicken Droppings is purely a skill-based mini-game. Payment is required to play. Players may practice for free but scores are not registered without connecting a Solana wallet.</p>

        {/* What is Chicken Drop */}
        <h2>3. WHAT IS CHICKEN DROP?</h2>
        <p>Chicken Drop is a reward based game played on the Solana blockchain. Rewards are provided with Solana as the prize. After playing Chicken Droppings Players earn the opportunity to select numbered squares on a grid. Once all squares are filled, a virtual chicken wanders across the grid and lays a golden egg on one square. The player who owns that square wins the prize pool.</p>
        <p>Three arena sizes are available:</p>
        <ul>
          <li>🐔 Mini Coop — 4×4 grid, 16 squares, 0.02 SOL entry</li>
          <li>🐔 Standard Coop — 5×5 grid, 25 squares, 0.02 SOL entry</li>
          <li>🐔 Mega Coop — 10×10 grid, 100 squares, 0.02 SOL entry</li>
        </ul>
        <p>The game is provably fair and the smart contract can be read on the Solana blockchain— the winning square is determined randomly once all squares are filled. No administrator or developer can influence or predict the outcome.</p>

        {/* How to Play */}
        <h2>4. HOW TO PLAY</h2>
        <h3>STEP 1 — SELECT YOUR ARENA</h3>
        <p>From the landing page choose your preferred arena size (Mini, Standard, or Mega Coop).</p>
        <h3>STEP 2 — PLAY CHICKEN DROPPINGS</h3>
        <p>Connect your Solana wallet and pay the 0.02 SOL entry fee to play Chicken Droppings. Survive as many rounds as possible to earn free squares.</p>
        <h3>STEP 3 — PICK YOUR SQUARE</h3>
        <p>After playing, select your square on the Chicken Drop grid. You get 1 free square.</p>
        <h3>STEP 4 — WAIT FOR THE DROP</h3>
        <p>Once all squares are filled the chicken enters the arena. The chicken wanders for 20–40 seconds before laying the golden egg on the winning square. The winner receives the prize pool automatically.</p>

        {/* Chicken Droppings Scoring */}
        <h2>5. CHICKEN DROPPINGS SCORING</h2>
        <p>Points are awarded as follows and determine your leaderboard position for Bonanza eligibility:</p>
        <ul>
          <li>Round 1 completion: 5,000 pts</li>
          <li>Round 2 completion: 7,500 pts</li>
          <li>Round 3 completion: 10,000 pts</li>
          <li>Round 4 completion: 20,000 pts</li>
          <li>Round 5 completion: 30,000 pts</li>
          <li>Round 6 completion: 50,000 pts</li>
          <li>Round 7 completion: 70,000 pts</li>
          <li>Round 8 completion: 100,000 pts</li>
          <li>Round 9 completion: 140,000 pts</li>
          <li>Round 10 completion: 200,000 pts</li>
          <li>Each weapon hit: +1,000 pts</li>
          <li>Each baby farmer hit: +500 pts</li>
          <li>Fox bonus 🦊: +5,000 pts</li>
          <li>Shoot the Bird Flu Virus 🦠: +2,500 pts</li>
          <li>Miss the Bird Flu Virus (escape penalty) 🦠: -2,500 pts</li>
          <li>Farmer's Wife frying pan hit 🍳: +5,000 pts</li>
          <li>Farmer's Wife frying pan miss 🍳: -5,000 pts</li>
          <li>Super Hawk hit 🦅: +5,000 pts each</li>
          <li>Super Hawk miss 🦅: -5,000 pts each</li>
          <li>Complete all 10 rounds bonus: +200,000 pts</li>
        </ul>
        <p>An accuracy multiplier is applied to your total score:</p>
        <ul>
          <li>80%+ accuracy → ×2.5 multiplier</li>
          <li>75–79% accuracy → ×2.4 multiplier</li>
          <li>70–74% accuracy → ×2.3 multiplier</li>
          <li>65–69% accuracy → ×2.2 multiplier</li>
          <li>60–64% accuracy → ×2.1 multiplier</li>
          <li>55–59% accuracy → ×2.0 multiplier</li>
          <li>50–54% accuracy → ×1.9 multiplier</li>
          <li>45–49% accuracy → ×1.8 multiplier</li>
          <li>40–44% accuracy → ×1.7 multiplier</li>
          <li>35–39% accuracy → ×1.6 multiplier</li>
          <li>30–34% accuracy → ×1.5 multiplier</li>
          <li>25–29% accuracy → ×1.4 multiplier</li>
          <li>20–24% accuracy → ×1.3 multiplier</li>
          <li>15–19% accuracy → ×1.2 multiplier</li>
          <li>10–14% accuracy → ×1.1 multiplier</li>
          <li>Under 10% accuracy → ×1.0 (no multiplier)</li>
        </ul>
        <p>Leaderboard scores are verified server-side and used to determine Bonanza eligibility. The top 100 scores qualify for a free Bonanza square when a Bonanza draw is triggered.</p>

        {/* Prize Pool Distribution */}
        <h2>6. PRIZE POOL DISTRIBUTION</h2>
        <p>Every Chicken Dropping game Pay-to-Play fee is distributed as follows:</p>
        <ul>
          <li>80% → Chicken Drop prize pool (winner takes all)</li>
          <li>10% → Ongoing platform development</li>
          <li>10% → Bonanza pool prize (accumulates across all games)</li>
        </ul>
        <p>This distribution applies to all arena sizes and all entry types (mini-game entry at 0.02 SOL and Chicken Drop game accelerator fee at 0.025 SOL). Free squares earned through gameplay do not contribute to the pool but qualify for the Chicken Drop pool prize.</p>

        {/* Winning Odds */}
        <h2>7. WINNING ODDS</h2>
        <p>Your odds of winning any given Chicken Drop round depend on how many squares you own relative to total squares filled:</p>
        <ul>
          <li>Mini Coop (16 squares): 1 square = 1 in 16 chance (6.25%)</li>
          <li>Standard Coop (25 squares): 1 square = 1 in 25 chance (4.0%)</li>
          <li>Mega Coop (100 squares): 1 square = 1 in 100 chance (1.0%)</li>
        </ul>
        <p>Owning multiple squares increases your odds proportionally. Players who own 2 squares in a 16-square Mini Coop have a 12.5% chance of winning. There is no guaranteed way to win. All outcomes are random.</p>

        {/* The Bonanza */}
        <h2>8. THE BONANZA</h2>
        <p>The Bonanza is a special bonus draw that activates once the accumulated Bonanza pool reaches 25 SOL.</p>
        <p>When triggered:</p>
        <ul>
          <li>A 15-minute countdown begins</li>
          <li>The top 100 Chicken Droppings leaderboard scores each receive one free square in a special 10×10 Bonanza arena</li>
          <li>The chicken performs a special drop on the Bonanza arena</li>
          <li>The winner takes the entire accumulated Bonanza pool</li>
          <li>The Bonanza pool resets to zero and accumulation restarts</li>
        </ul>
        <p>Bonanza eligibility is determined solely by Chicken Droppings score. Any player who has played Chicken Droppings and ranks in the top 100 scores is automatically eligible. No additional payment is required for Bonanza participation. To prevent bots and game manipulation, a human verification test must be passed by the Player before a score is added to the top 100 leaderboard.</p>

        {/* Fund Protection */}
        <h2>9. HOW FUNDS ARE PROTECTED</h2>
        <p>All transactions are processed on the Solana blockchain. Smart contract logic governs prize distribution automatically — no human administrator controls or can redirect prize funds once a round begins.</p>
        <p>Square ownership is recorded on-chain and immutable. Once a square is purchased it cannot be reassigned or revoked. In the event of simultaneous purchase attempts on the same square the blockchain enforces first-come-first-served priority and any failed transaction is automatically refunded.</p>
        <p>The platform does not hold or custody user funds beyond the duration of a single game round. Prize distribution occurs automatically at round completion.</p>

        {/* Disclaimers */}
        <h2>10. DISCLAIMERS & RISK WARNING</h2>
        <p>Chicken Drop is a pay to play a video game so by playing the game you have some financial risk. By playing you acknowledge and accept all of the following:</p>
        <ul>
          <li>This platform is provided "as is" without warranty of any kind</li>
          <li>The platform operator is not liable for any financial losses incurred through participation</li>
          <li>Blockchain transactions are irreversible — errors cannot be undone</li>
          <li>The platform may be unavailable due to maintenance, network issues, or other factors outside our control</li>
          <li>Smart contract code may contain bugs or vulnerabilities despite best efforts to audit and test</li>
          <li>Regulatory changes may affect the availability of this platform in your jurisdiction at any time</li>
          <li>Past results do not guarantee future outcomes — every round is independent</li>
        </ul>

        {/* No Guarantees */}
        <h2>11. NO GUARANTEES</h2>
        <p>The platform operator makes no guarantees regarding:</p>
        <ul>
          <li>Continuous or uninterrupted availability of the platform</li>
          <li>The speed or confirmation time of blockchain transactions</li>
          <li>The future value of any prizes won</li>
          <li>The number of players participating in any given round</li>
        </ul>

        {/* Limitation of Liability */}
        <h2>12. LIMITATION OF LIABILITY</h2>
        <p>To the maximum extent permitted by applicable law, the platform operator shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use this platform, including but not limited to loss of funds, loss of data, or loss of profits.</p>
        <p>Your sole remedy for dissatisfaction with this platform is to stop using it.</p>

        {/* Changes to Terms */}
        <h2>13. CHANGES TO THESE TERMS</h2>
        <p>These terms may be updated at any time. Continued use of the platform after changes are posted constitutes acceptance of the revised terms. It is your responsibility to review these terms periodically.</p>

        {/* Footer */}
        <div style={{ borderTop: '1px solid #222', marginTop: 60, paddingTop: 24, textAlign: 'center', color: '#444', fontSize: 11 }}>
          <p>© 2026 Chicken Drop. All rights reserved.</p>
          <p style={{ marginTop: 8 }}>
            <Link to="/" style={{ color: '#F0B800', textDecoration: 'none' }}>← Back to Chicken Drop</Link>
          </p>
        </div>

      </div>
    </div>
  );
}
